export default "__VITE_ASSET__DrzR7Zbj__"